// Validation helpers for the corporate enquiry form.
// Kept out of the component so each rule stays small and unit-testable.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const PHONE_RE = /^[0-9+()\-\s]{5,40}$/;

export const EMPTY_ENQUIRY = {
  full_name: "",
  email: "",
  phone: "",
  service: "",
  message: "",
  company_website: "",
};

export const validateFullName = (value) =>
  value.trim().length >= 2 ? undefined : "Please enter your full name";

export const validateEmail = (value) =>
  EMAIL_RE.test(value.trim()) ? undefined : "Please enter a valid email address";

export const validatePhone = (value) => {
  const phone = value.trim();
  if (!phone) return undefined;
  return PHONE_RE.test(phone) ? undefined : "Please enter a valid phone number";
};

export const validateService = (value) =>
  value ? undefined : "Please choose an enquiry type";

export const validateMessage = (value) =>
  value.trim().length >= 5 ? undefined : "Please tell us a little about your enquiry";

const RULES = {
  full_name: validateFullName,
  email: validateEmail,
  phone: validatePhone,
  service: validateService,
  message: validateMessage,
};

/** Returns an object of field -> error message (empty when the form is valid). */
export const validateEnquiry = (form) =>
  Object.entries(RULES).reduce((errors, [field, rule]) => {
    const error = rule(form[field] ?? "");
    if (error) errors[field] = error;
    return errors;
  }, {});

/** Shapes the form state into the payload expected by POST /api/contact. */
export const toEnquiryPayload = (form) => ({
  full_name: form.full_name.trim(),
  email: form.email.trim(),
  phone: form.phone.trim() || null,
  service: form.service,
  message: form.message.trim(),
  company_website: form.company_website,
});
